import React from 'react';
import PropTypes from 'prop-types';

const styles = {
    positionInput: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    inputArrows: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingLeft: '5px'
    },
    inputArrow: {
        cursor: 'pointer',
        color: '#BEBEBE',
        lineHeight: '1em'
    }
};

export default function PositionInput({ min = 0, max = Infinity, onUp, onDown, position }) {
    return (
        <div className="position-input" style={styles.positionInput}>
            <span>{position + 1}</span>
            <div className="position-input-arrows" style={styles.inputArrows}>
                {position > min && (
                    <div onClick={onDown} style={styles.inputArrow}>
                        ▲
                    </div>
                )}
                {position < max - 1 && (
                    <div onClick={onUp} style={styles.inputArrow}>
                        ▼
                    </div>
                )}
            </div>
        </div>
    );
}

PositionInput.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    onUp: PropTypes.func.isRequired,
    onDown: PropTypes.func.isRequired,
    position: PropTypes.number.isRequired
};
